import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';
import NoticeBox from '../components/shared/NoticeBox';
import Audits from '../components/shared/Audits';

import { adminUser, managerUser, hideElementForNonAdmins, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'

class DeviceForm extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.resetDevice = this.resetDevice.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    name: "",
    location_id: "",
    qr_code_size: "default",
    profile_overflow: "scroll",
    profile_ids: [],

    locations: [],
    profiles: [],

    resetMessage: "",

    loaded: false,
    locationsLoaded: false,
    profilesLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleMultiCheckbox(event) {
    let name = parseInt(event.target.name);
    let value = event.target.checked;

    var profile_ids = this.state.profile_ids

    if (value === true) {
      if (!profile_ids.includes(name)) {
        profile_ids.push(name)
      }
    }
    else if (value === false) {
      if (profile_ids.includes(name)) {
        let index = profile_ids.indexOf(name)
        profile_ids.splice(index, 1)
      }
    }

    this.setState({profile_ids: profile_ids});
  }

  resetDevice(event) {
    const id = this.props.id;

    request('DELETE', `/v1/a/devices/${id}/reset_device`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ resetMessage: "Device successfully reset" })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ resetMessage: "Sorry, something went wrong", error })
      })
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = JSON.stringify({
      "device": {
        "name": this.state.name,
        "qr_code_size": this.state.qr_code_size,
        "profile_overflow": this.state.profile_overflow,
        "location_id": this.state.location_id,
        "profile_ids": this.state.profile_ids,
      }
    })

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/devices/${id}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Device ${this.props.mode}d successfully!`);

        if (this.props.mode === "create") {
          this.setState({ id: data.id, redirect: true })
        }
        else if (this.props.mode === "update") {
          this.props.closeEditPanel()
        }
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  render() {
    const { name, location_id, qr_code_size, profile_overflow, profile_ids, locations, profiles, resetMessage, loaded, locationsLoaded, profilesLoaded, id, redirect, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/configuration/devices/${id}`}/>
    }

    if (loaded === false || locationsLoaded === false || profilesLoaded === false) {
      return <p>Loading ...</p>;
    }

    const disableNonProfileFields = (managerUser() === true && adminUser() === false)

    const title = this.props.mode === "create" ? "New" : "Edit"
    const formatName = name ? ` ${name} |` : ""

    return (
      <div>
        <SetTitle title={`${title} Device |${formatName} Devices`} />

        <form className="settings big-settings" onSubmit={this.handleSubmit}>
          {disableNonProfileFields &&
            <NoticeBox type="info" text="As a Manager, you may only assign and unassign Profiles to this Device. Only Admins can change other fields." />
          }

          <div className="row">
            <HelpText page={'device'} section={'name'} />

            <label className="column">Device Name:</label>{ renderErrors(errors, 'name') }
            <input className="column" type="text" name="name" value={name} onChange={this.handleChange} disabled={disableNonProfileFields} />
          </div>

          <div className="row">
            <HelpText page={'device'} section={'location'} />

            <label className="column">Location:</label>{ renderErrors(errors, 'location') }
            <select name="location_id" onChange={this.handleChange} value={location_id} disabled={disableNonProfileFields}>
              <option value="">Select</option>
              {locations.map((location) => (
                <option value={location.id} key={location.id}>{location.name}</option>
              ))}
            </select>
          </div>

          <div className="row">
            <HelpText page={'device'} section={'qr_code_size'} />

            <label className="column">QR Code Size:</label>{ renderErrors(errors, 'qr_code_size') }
            <div className="qr-code-options">
              <div className="qr-code-option">
                <input className="column" type="radio" name="qr_code_size" id="default" value="default" checked={qr_code_size === "default"} onChange={this.handleChange} disabled={disableNonProfileFields} />
                <label htmlFor="default">Default</label>
                <div/>
                <label className="sample-qr" htmlFor="default">Default QR size</label>
              </div>

              <div className="qr-code-option">
                <input className="column" type="radio" name="qr_code_size" id="small" value="small" checked={qr_code_size === "small"} onChange={this.handleChange} disabled={disableNonProfileFields} />
                <label htmlFor="small">Small</label>
                <div/>
                <label className="sample-qr-small" htmlFor="small">Reduced size</label>
              </div>
            </div>
          </div>

          <div className="row">
            <HelpText page={'device'} section={'profile_overflow'} />

            <label className="column">Profile overflow solution:</label>{ renderErrors(errors, 'profile_overflow') }
            <div className="qr-code-options">
              <div className="qr-code-option">
                <input className="column" type="radio" name="profile_overflow" id="scroll" value="scroll" checked={profile_overflow === "scroll"} onChange={this.handleChange} />
                <label htmlFor="scroll">Profiles always on one row</label>
              </div>

              <div className="qr-code-option">
                <input className="column" type="radio" name="profile_overflow" id="rows" value="rows" checked={profile_overflow === "rows"} onChange={this.handleChange} />
                <label htmlFor="rows">Profiles appear on multiple rows</label>
              </div>
            </div>
          </div>

          <div className="row">
            <HelpText page={'device'} section={'profiles'} />

            <label className="column">Profiles:</label>{ renderErrors(errors, 'profile') }
            <div className="scrollable-table">
              <table className="checkbox-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Use</th>
                  </tr>
                </thead>
                <tbody>
                  {profiles.map((profile) => (
                    <tr key={profile.id}>
                      <td>
                        <Link to={`/configuration/profiles/${profile.id}`}>{profile.name}</Link>
                      </td>
                      <td>
                        {profile.display_name}
                      </td>
                      <td className="center-cell">
                        <input className="column" type="checkbox" data-name={profile.name} name={profile.id} checked={profile_ids.includes(profile.id)} onChange={this.handleMultiCheckbox} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          { this.renderSaveButton() }
          { renderErrorWarning(errors) }
        </form>

        {this.props.mode === "update" &&
          <>
            <div className={`reset-device big-settings ${hideElementForNonAdmins()}`}>
              <HelpText page={'device'} section={'resetDevice'} />

              <div className="button new-button red-button" onClick={this.resetDevice}>Reset Device</div>
              <p>{resetMessage}</p>
            </div>

            <Audits klass="Device" id={this.props.id} />
          </>
        }
      </div>
    );
  }

  componentDidMount() {
    let id = this.props.id;

    if (this.props.mode === "create") {
      this.setState({ loaded: true })
    }
    else {
      request('GET', `/v1/a/devices/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            name: data.name,
            location_id: data.location_id,
            qr_code_size: data.qr_code_size,
            profile_overflow: data.profile_overflow,
            profile_ids: data.profile_ids,
            loaded: true
          })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }

    request('GET', `/v1/a/locations/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ locations: data, locationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, locationsLoaded: true })
      })

    request('GET', `/v1/a/profiles/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ profiles: data, profilesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, profilesLoaded: true })
      })

  }
}

export default DeviceForm;
